import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import { ViewLimitsSection } from '../components/ViewLimitsSection';
import { getLangStringsForStrategy } from '../utils/getLangStringsForStrategy';

/**
 * Will return an array of length 3
 * - the first index will be a boolean. This boolean represents "is this an error that should prevent a user from creating/cloning this view"
 * - the second index will be an optional affordance (such as the view limit progressbar)
 * - the third index will be an optional validation message for the view name text input
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const useCreateViewModalErrors = ({
  isNameEmpty,
  isNameUsed,
  isFetchError,
  isCreateError,
  viewCountValue,
  viewCountLimit,
  createStrategy
}) => {
  return useMemo(() => {
    const {
      errors
    } = getLangStringsForStrategy({
      strategy: createStrategy
    });
    const ViewLimitsComponent =
    /*#__PURE__*/
    //watch out - viewCountValue/viewCountLimit are numbers that can be 0 which are falsey - the explicit undefined checks are meaningful
    _jsx(_Fragment, {
      children: viewCountLimit !== undefined && viewCountValue !== undefined && /*#__PURE__*/_jsx(ViewLimitsSection, {
        count: viewCountValue,
        limit: viewCountLimit
      }, "view-limits-section")
    });
    if (isNameEmpty) {
      return [true, ViewLimitsComponent, /*#__PURE__*/_jsx(FormattedMessage, {
        message: errors.emptyName
      }, "isNameEmptyError")];
    } else if (isNameUsed) {
      return [true, ViewLimitsComponent, /*#__PURE__*/_jsx(FormattedMessage, {
        message: errors.duplicateName
      }, "isNameEmptyError")];
    } else if (
    //watch out - viewCountValue/viewCountLimit are numbers that can be 0 which are falsey - the explicit undefined checks are meaningful
    viewCountValue !== undefined && viewCountLimit !== undefined && viewCountValue >= viewCountLimit) {
      return [true, ViewLimitsComponent, /*#__PURE__*/_jsx(FormattedMessage, {
        message: errors.atOrAboveLimit
      }, "isNameEmptyError")];
    } else if (isFetchError) {
      return [true, ViewLimitsComponent, /*#__PURE__*/_jsx(FormattedMessage, {
        message: errors.fetchError
      }, "isNameEmptyError")];
    } else if (isCreateError) {
      return [true, ViewLimitsComponent, /*#__PURE__*/_jsx(FormattedMessage, {
        message: errors.createError
      }, "isNameEmptyError")];
    }
    return [false, ViewLimitsComponent, null];
  }, [createStrategy, isCreateError, isFetchError, isNameEmpty, isNameUsed, viewCountLimit, viewCountValue]);
};